import { FC } from 'react';
import { styled } from '@mui/material/styles';

const StyledSpan = styled('span')`
  word-break: break-all;
`;

export const LongTextCellRenderer: FC<{ value: string | undefined }> = ({ value }) => {
  return <StyledSpan>{value}</StyledSpan>;
};
